import { createSlice } from '@reduxjs/toolkit';

interface CalendarDateState {
	[rutaKey: string]: string | null; // fecha en formato ISO o null
}

const initialState: CalendarDateState = {};

const calendarSelectedDateSlice = createSlice({
	name: 'calendarSelectedDate',
	initialState,
	reducers: {
		setCalendarDate: (state, action) => {
			const { rutaKey, date } = action.payload;
			return {
				...state,
				[rutaKey]: date
			};
		},
		resetCalendarDate: (state, action) => {
			const { rutaKey } = action.payload;
			return {
				...state,
				[rutaKey]: null
			};
		}
	}
});

export const { setCalendarDate, resetCalendarDate } = calendarSelectedDateSlice.actions;
export default calendarSelectedDateSlice.reducer;
